// extracted by mini-css-extract-plugin
export default {"modalBody":"ChangeProjectRoleModal-module__modalBody___oKmyW","assignmentUpdateWarning":"ChangeProjectRoleModal-module__assignmentUpdateWarning___Nf5yh"};